import React from "react";
import { toast } from "react-toastify";
import AudioRecordView from "./view";
import { noop } from "@client/shared/constants";
import { getFileExtension } from "@client/utils";

const MAX_ALLOWED_FILE_SIZE = 20;
const MIN_ALLOWED_FILE_DURATION = 3;
const MAX_ALLOWED_FILE_DURATION = 180;
const SUPPORTED_FILE_FORMATS = ["mp3", "wav", "x-wav"];

const AudioRecordPanel = ({
  recordingType = 1,
  voicemailList = [],
  selectedVoicemail = {},
  uploadedVoicemail = null,
  recordedVoicemail = null,
  recordedVoicemailTitle = "",
  callToRecordVoicemail = null,
  callToRecordVoicemailNumber = null,
  callToRecordVoicemailTitle = "",
  roleAccess = {},
  phoneNumberList = [],
  countryList = [],
  handleChange = noop,
  handleJwksResponse = noop,
}) => {
  
  const handleFileChange = (evt) => {
    const file = evt.target.files[0];
    const { name, size } = file;
    const fileExtension = getFileExtension(name);
    if (size > MAX_ALLOWED_FILE_SIZE * 1048576) {
      return toast.error(
        `Size of "${file.name}" is more than ${MAX_ALLOWED_FILE_SIZE} mb.`
      );
    } else if (!SUPPORTED_FILE_FORMATS.includes(fileExtension.toLowerCase())) {
      return toast.error(
        `Only ${SUPPORTED_FILE_FORMATS.join(", ")} formats are supported.`
      );
    }
    let objectURL = URL.createObjectURL(file);
    let mySound = new Audio([objectURL]);
    mySound.addEventListener("canplaythrough", () => {
      URL.revokeObjectURL(objectURL);
      if (
        mySound.duration > MIN_ALLOWED_FILE_DURATION &&
        mySound.duration <= MAX_ALLOWED_FILE_DURATION
      ) {
        handleChange(
          {
            name: "uploadedVoicemail",
            value: file,
          },
          "custom"
        );
      } else {
        const message =
          mySound.duration < MIN_ALLOWED_FILE_DURATION
            ? `Length of "${file.name}" is less than ${MIN_ALLOWED_FILE_DURATION} seconds.`
            : `Length of "${file.name}" is more than ${
                MAX_ALLOWED_FILE_DURATION / 60
              } minutes.`;
        return toast.error(message);
      }
    });
  };

  return (
    <AudioRecordView
      recordingType={recordingType}
      voicemailList={voicemailList}
      selectedVoicemail={selectedVoicemail}
      uploadedVoicemail={uploadedVoicemail}
      recordedVoicemail={recordedVoicemail}
      recordedVoicemailTitle={recordedVoicemailTitle}
      callToRecordVoicemail={callToRecordVoicemail}
      callToRecordVoicemailNumber={callToRecordVoicemailNumber}
      callToRecordVoicemailTitle={callToRecordVoicemailTitle}
      handleChange={handleChange}
      SUPPORTED_FILE_FORMATS={SUPPORTED_FILE_FORMATS}
      roleAccess={roleAccess}
      phoneNumberList={phoneNumberList}
      countryList={countryList}
      handleFileChange={handleFileChange}
      handleJwksResponse={handleJwksResponse}
    />
  );
};

export default AudioRecordPanel;
